import { useQuery } from "@tanstack/react-query"
import { getTintVTOService } from "services/tintvto.ts"

interface FontsData {
  [fontName: string]: {
    [style: string]: string[]
  }
}

export const useFonts = () => {
  return useQuery<FontsData, Error>({
    queryKey: ["fonts"],
    queryFn: async () => {
      const service = getTintVTOService()
      const { data } = await service.listFonts()
      return JSON.parse(data.listFonts) as FontsData
    },
    staleTime: 1000 * 60 * 20, // Cache the data for 20 minutes
  })
}
